import styled from 'styled-components';
import OpenDialogIcon from './OpenDialogIcon';

export default styled(OpenDialogIcon)`
  font-size: 1.25rem;
  vertical-align: middle;
  color: ${({ isActive, theme }) => (isActive ? theme.primaryColor : '#737376')};
  margin-left: 5px;
`;
